import Navbar from "@/pages/home/components/Navbar";
import PageBanner from "@/pages/home/components/PageBanner";
import InvestOptions from "@/pages/home/components/InvestOptions";
import Footer from "@/pages/home/components/Footer";
import CmsPage from "@/components/cms/CmsPage";

export default function InvestmentsPage() {
  return (
    <main className="w-full">
      <Navbar />
      <CmsPage slug="investments" path="/investments" fallbackSeo={{ title: "Villa Investment Opportunities | NOMADLIVINGS", description: "Curated A-frame villa opportunities engineered for consistent rental income, appreciation and unforgettable stays." }}>
      <PageBanner
        eyebrow="Investments"
        title="Villa Investment"
        highlight="Opportunities"
        subtitle="Explore curated A-frame villa opportunities engineered to generate consistent rental income, long-term appreciation and unforgettable stays."
        image="https://readdy.ai/api/search-image?query=Stunning%20aerial%20view%20of%20luxury%20A-frame%20wooden%20villas%20arranged%20in%20a%20mountain%20resort%20with%20lush%20green%20forest%2C%20winding%20paths%20and%20outdoor%20pools%20at%20golden%20hour%2C%20warm%20amber%20and%20green%20tones%2C%20premium%20hospitality%20real%20estate%20photography%2C%20high%20detail&width=1800&height=900&seq=banner-investments-x2&orientation=landscape&nocache=true"
        imageAlt="Aerial view of luxury A-frame villas in a mountain resort at golden hour"
        ctaLabel="Schedule a Site Visit"
        ctaTo="/contact"
      />
      <InvestOptions />
      </CmsPage>
      <Footer />
    </main>
  );
}